import * as searchComposables from '@Composables/SearchComposables';
import LocationFilterSetting from '@Types/search/LocationFilterSetting';


export enum ClearLocationAction {

    Default = 1,
    ResetEntireFilter = 2
}


export function determineClearLocationFilterAction(): ClearLocationAction{
// this function helps to determine what action to take when clearing a location filter.
// this is not straight forward, as it depends on what kind of page we are on. for instance,
// on a landing page this would typically reset the entire filter.
// this filter returns if the actions means to reset the enitre page, or continue with
// the default action.

    if (searchComposables.getSearchMetaDefinitions().locationFilterSetting == LocationFilterSetting.Auto) {

        // for auto the default clear options should be taken.
        return ClearLocationAction.Default;
    }

    // currently for all the rest, clearing means to remove the entire landing page (or provider page) filter.
    // meaning to redirect to the search or map search page.

    return ClearLocationAction.ResetEntireFilter;

}